var _path, _path2, _path3, _path4, _circle, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFourthPercentile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.3283 34.8141C73.6491 41.3026 72.8117 48.8804 70.0664 54.9061C67.3211 60.9317 62.7387 65.9336 56.9759 69.1948L48.8128 54.7701C51.5294 53.2328 53.6896 50.8749 54.9837 48.0344C56.2778 45.1939 56.6395 42.0166 56.0168 38.958L72.3283 34.8141Z",
    fill: "#5A89FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.096 68.8249C20.3326 65.5649 15.7491 60.564 13.0026 54.5389C10.256 48.5139 9.48735 41.774 10.8068 35.2852L27.0487 38.5878C26.4267 41.6467 26.7891 44.8238 28.0838 47.6641C29.3785 50.5043 31.5392 52.8617 34.2561 54.3984L26.096 68.8249Z",
    fill: "#5A89FF",
    fillOpacity: 0.15
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4339 10.3179C49.0432 10.7215 56.3651 13.4986 61.4749 17.7098C66.5847 21.9211 70.2301 27.642 71.8887 34.0524L55.8428 38.204C55.0609 35.1821 53.3424 32.4853 50.9337 30.5001C48.5249 28.5149 45.5495 27.3432 42.4339 27.153L42.4339 10.3179Z",
    fill: "#5A89FF",
    fillOpacity: 0.72
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9711 34.161C12.851 27.8119 17.1898 21.0643 22.4426 17.0328C27.6954 13.0013 34.5253 10.5853 41.1445 10.4113L41.1445 27.1307C38.0242 27.2127 35.0099 28.2805 32.5338 30.181C30.0576 32.0814 28.2466 34.717 27.3604 37.7099L10.9711 34.161Z",
    fill: "#5A89FF",
    fillOpacity: 0.45
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.6427,
    cy: 40.3436,
    r: 3.86253,
    transform: "rotate(127.128 40.6427 40.3436)",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6205 47.8973L37.8846 42.451L41.9227 37.117L50.6205 47.8973Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFourthPercentile);
export default __webpack_public_path__ + "static/media/fourth-percentile.ada666240f6653156ea64b1298408f02.svg";
export { ForwardRef as ReactComponent };